import Vue from 'vue'
import App from './App.vue'
import router from './router'

// import { MdButton, MdContent, MdTabs, MdApp, MdToolbar } from 'vue-material/dist/components'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import store from './store'
// import 'vue-material/dist/theme/default.css'

Vue.config.productionTip = false
Vue.use(VueMaterial)

Vue.filter('currency', function(value){
  return `$${Number.parseFloat(value).toFixed(2)}`
});
Vue.filter('date', function(value){
  let d = new Date(value);
  let month = d.toLocaleDateString('en-US', { timeZone: "America/New_York", month: "2-digit" });
  let date = d.toLocaleDateString('en-US', { timeZone: "America/New_York", day: "2-digit" });
  let year = d.toLocaleDateString('en-US', { timeZone: "America/New_York", year: "numeric" });
  return `${month}/${date}/${year}`
})
Date.prototype.toIsoString = function() {
  var tzo = -this.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function(num) {
          var norm = Math.floor(Math.abs(num));
          return (norm < 10 ? '0' : '') + norm;
      };
  return this.getFullYear() +
      '-' + pad(this.getMonth() + 1) +
      '-' + pad(this.getDate()) +
      'T' + pad(this.getHours()) +
      ':' + pad(this.getMinutes()) +
      ':' + pad(this.getSeconds()) +
      dif + pad(tzo / 60) +
      ':' + pad(tzo % 60);
}
// Vue.use(MdApp)
// Vue.use(MdButton)
// Vue.use(MdContent)
// Vue.use(MdTabs)
// Vue.use(MdToolbar)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
